import { TAG_SORT_ALPHABETICAL } from "@/utils/tags";

export class ClientConfig {
  constructor(config, id) {
    this.id = id;
    if (!config) {
      this.intake = {};
      this.priorAuth = {};
      this.submissionMethod = null;
      this.key = null;
      this.tagSortOrder = TAG_SORT_ALPHABETICAL;
      this.documentBuckets = [];
      return;
    }
    this.intake = { ...config.uiConfig.intake };
    this.priorAuth = { ...config.uiConfig.priorAuth };
    this.submissionMethod = config.uiConfig?.submissionMethod;
    this.key = config.uiConfig.key;
    this.defaultPostLoginPage = config.uiConfig?.defaultPostLoginPage || "all-submissions";
    this.isAdminCompany = config.isAdminCompany ?? false;
    this.documentBuckets = config.documentBuckets ?? [];
    this.salesDemoLauncherEnabled = config.uiConfig?.salesDemoLauncherEnabled ?? false;
    this.escalationsEnabled = config.uiConfig?.escalationsEnabled ?? false;
    this.worklistEnabled = config.uiConfig?.worklistEnabled ?? false;
    this.missionControlEnabled = config.uiConfig?.missionControlEnabled ?? false;
    this.medicalNecessityEnabled = config.medicalNecessityEnabled ?? !this.intake.skipClinicalReview;
    this.benefitsVerificationEnabled = config.benefitsVerificationEnabled ?? true;
    this.tagSortOrder = config.uiConfig?.tagSortOrder || TAG_SORT_ALPHABETICAL;
  }
}
